export const API_EXTERNAL_ENDPOINT = 'cottage-reviews/province/:province_slug'

export const API_INTERNAL_ENDPOINT =
  'rurality/v3/cottage-reviews/province/detail'
